import { render, staticRenderFns } from "./shebei.vue?vue&type=template&id=55518839&"
import script from "./shebei.vue?vue&type=script&lang=js&"
export * from "./shebei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports